import { Navigate } from "react-router-dom-v5-compat";

type Props = {
  isAllowed: boolean;
  redirectPath: string;
  children: JSX.Element;
};

export default function ProtectedRoute({
  isAllowed,
  redirectPath,
  children
}: Props) {
  if (isAllowed) {
    return children;
  }

  return <Navigate to={redirectPath} replace />;
}
